import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector } from "react-redux";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
export default function ServiceInfo({
  serviceInfo,
  serviceInfoId,
  serviceInfoClinc,
  setServiceInfo,
}) {
  const data = useSelector(
    (state) => state.main.data?.servicesImagesData
  )?.filter(
    (item) =>
      item.service_id == serviceInfoId && item.clinc_id == serviceInfoClinc
  );
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);

  return (
    serviceInfo === true && (
      <div className="service-info" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setServiceInfo(false)}
        ></div>
        {isMobile ? (
          <Swiper
            effect={"cards"}
            grabCursor={true}
            modules={[EffectCards]}
            className="container "
          >
            {data?.map((section) => (
              <SwiperSlide className="section">
                <div className={isMobile ? "image active" : "image"}>
                  <img
                    src={`https://api.atharalfarasha.com/public/hakim/${section?.service_image}`}
                    alt=""
                  />
                </div>
                <div className={isMobile ? "data active" : "data"}>
                  <div className="layout"></div>
                  <div className="title">
                    <span>تفاصيل عن الحالة</span>
                  </div>
                  <div className="desc">{section?.service_desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            slidesPerView={"auto"}
            centeredSlides={true}
            spaceBetween={20}
            modules={[Pagination]}
            className="container "
          >
            {data?.map((section) => (
              <SwiperSlide className="section">
                <div className={isMobile ? "image active" : "image"}>
                  <img
                    src={`https://api.atharalfarasha.com/public/hakim/${section?.service_image}`}
                    alt=""
                  />
                </div>
                <div className={isMobile ? "data active" : "data"}>
                  <div className="layout"></div>
                  <div className="title">
                    <span>تفاصيل عن الحالة</span>
                  </div>
                  <div className="desc">{section?.service_desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    )
  );
}
